module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/be1537a45eb149bff6a9c4d7b38497e4.svg";